import React from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Iconify from '../common/iconify.component';

const SearchList = ({
  label,
  handleSearch,
  inputRef,
  onChange,
  options,
  clearSearch,
}) => (
  <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
    <TextField
      placeholder={`Search ${label}...`}
      type="text"
      inputRef={inputRef}
      onChange={onChange}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleSearch();
        }
      }}
      sx={{
        width: { xs: '100%', sm: '280px' },
        '& .MuiOutlinedInput-root': {
          height: '40px',
          paddingLeft: '12px',
          paddingRight: '8px',
          borderRadius: '20px',
          backgroundColor: (theme) => alpha(theme.palette.grey[500], 0.01),
          transition: (theme) =>
            theme.transitions.create(
              ['box-shadow', 'background-color', 'border-color'],
              {
                duration: theme.transitions.duration.shorter,
              }
            ),
          border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.08)}`,
          '& fieldset': {
            border: 'none',
          },
          '&:hover': {
            backgroundColor: (theme) => alpha(theme.palette.grey[500], 0.04),
            borderColor: (theme) => alpha(theme.palette.primary.main, 0.2),
          },
          '&.Mui-focused': {
            backgroundColor: (theme) => alpha(theme.palette.common.white, 1),
            boxShadow: (theme) =>
              `0 4px 12px 0 ${alpha(theme.palette.common.black, 0.1)}`,
            border: (theme) =>
              `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Iconify
              icon="fe:search"
              sx={{ color: 'text.disabled', width: 20, height: 20 }}
            />
          </InputAdornment>
        ),
        endAdornment: options.searchValue ? (
          <InputAdornment position="end">
            <IconButton
              onClick={() => clearSearch()}
              edge="end"
              size="small"
              sx={{ mr: 0.5 }}
            >
              <Iconify icon="mdi:close" width={18} height={18} />
            </IconButton>
            <IconButton
              onClick={handleSearch}
              edge="end"
              size="small"
              color="primary"
            >
              <Iconify
                icon="material-symbols:arrow-forward-rounded"
                width={20}
                height={20}
              />
            </IconButton>
          </InputAdornment>
        ) : null,
      }}
    />
  </Box>
);

SearchList.propTypes = {
  label: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired,
  inputRef: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.object.isRequired,
  clearSearch: PropTypes.func.isRequired,
};

export default SearchList;
